import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';
import { NEWS } from '@/constants/testIds';

export const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error('Please enter a valid email.');
      return;
    }
    setDone(true);
    toast.success('You’re on the list. Welcome to Trendy Closet ✨');
    setEmail('');
  };

  return (
    <section data-testid={NEWS.root} className="py-20 lg:py-24 bg-maroon relative overflow-hidden">
      <svg className="absolute -right-24 -top-24 w-[380px] h-[380px] opacity-10 text-gold pointer-events-none" viewBox="0 0 400 400" aria-hidden>
        <g stroke="currentColor" fill="none" strokeWidth="0.8" transform="translate(200 200)">
          {[...Array(24)].map((_, i) => (
            <g key={i} transform={`rotate(${(360 / 24) * i})`}>
              <path d="M0 0 C 40 -12, 80 -36, 120 0 C 80 36, 40 12, 0 0 Z" />
            </g>
          ))}
          <circle r="170" />
        </g>
      </svg>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="container-luxe relative grid lg:grid-cols-12 gap-8 lg:gap-10 items-center"
      >
        <div className="lg:col-span-7">
          <span className="overline text-gold">The Insider</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-ivory mt-3 leading-tight text-balance">
            First looks, festival edits &amp; quiet sales — in your inbox.
          </h2>
        </div>
        <form onSubmit={submit} className="lg:col-span-5 w-full">
          <div className="flex flex-col sm:flex-row w-full items-stretch bg-ivory border border-gold/40 focus-within:border-gold">
            <div className="flex items-center flex-1 min-w-0">
              <Mail className="w-4 h-4 text-maroon ml-4 shrink-0" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid={NEWS.email}
                placeholder="your@email.com"
                aria-label="Email address"
                className="flex-1 min-w-0 bg-transparent px-3 py-4 text-sm outline-none text-charcoal placeholder-charcoal/40"
              />
            </div>
            <button
              type="submit"
              data-testid={NEWS.submit}
              className="shrink-0 px-6 py-4 bg-burgundy text-ivory text-xs uppercase tracking-[0.18em] hover:bg-charcoal transition-colors duration-500"
            >
              {done ? 'Subscribed' : 'Subscribe'}
            </button>
          </div>
          <p className="text-xs text-ivory/60 mt-3">No spam. Unsubscribe anytime.</p>
        </form>
      </motion.div>
    </section>
  );
};

export default Newsletter;
